import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments';
import { Observable } from 'rxjs';
import { ResponseApiDto } from '../DTOs/_response-api.dto';
import { InternalTemplateEntity } from '../entities/internal-template.entity';

@Injectable({
    providedIn: 'root',
})
export class InternalTemplateApi {
    private prefix = 'internal-template';

    //* Injects
    private _httpClient = inject(HttpClient);

    /**
     * Busca todos os templates internos da company
     * @returns ResponseApiDto<InternalTemplateEntity[]>
     */
    public getAll(category?: string): Observable<ResponseApiDto<InternalTemplateEntity[]>> {
        try {
            const url = `${environment.API_BASE}${this.prefix}`;
            const params = new HttpParams().set('category', category ?? '');

            return this._httpClient.get<ResponseApiDto<InternalTemplateEntity[]>>(url, { params });
        } catch (error) {
            throw error;
        }
    }
}
